import type { Schedule } from "@/models/schedule";
import type { Video } from "@/models/video";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export async function getSchedule(
  userDate: string | null = null,
): Promise<APIResponse<Schedule[]>> {
  try {
    const resp = await callApi<Schedule[]>(
      `${API_BASE}/weekly_schedules?archived=false${
        userDate ? `&user_date=${userDate}` : ""
      }`,
    );
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Schedule[]>;
  }
}

export async function getArchivedSchedule(): Promise<APIResponse<Schedule>> {
  try {
    const resp = callApi<Schedule>(
      `${API_BASE}/weekly_schedules?archived=true`,
    );
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Schedule>;
  }
}

export async function getVideoOfDay(
  userDate: string | null = null,
): Promise<APIResponse<Video>> {
  try {
    const resp = callApi<Video>(
      `${API_BASE}/video_of_day${userDate ? `?user_date=${userDate}` : ""}`,
    );
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<Video>;
  }
}
